import { useNavigate } from "@solidjs/router";
import { onMount } from "solid-js";
import { useI18n } from "@/api/i18n";
import { Button } from "@/components/ui/button";
import { ERROR_IMAGE } from "@/constants/images";
import { MetaTitleWithSeparator } from "@/domains/business/seo";
import { usePostHog } from "@/hooks/usePostHog";
export default function ErrorRoute() {
  const navigate = useNavigate();
  const { capture } = usePostHog();

  onMount(() => {
    capture("fail_create_job_offer");
  });

  const backToJobOffers = () => {
    navigate("/job-offers/create/ai");
  };

  const { t } = useI18n();

  return (
    <div class="flex flex-col gap-4 items-center justify-center h-screen">
      <MetaTitleWithSeparator>
        {t("jobOffers.create.error.title")}
      </MetaTitleWithSeparator>
      <img src={ERROR_IMAGE} alt="Error" class="w-1/4 mx-auto" />
      <h1 class="text-4xl font-medium text-center">
        {t("jobOffers.create.error.title")}
      </h1>
      <Button onClick={backToJobOffers}>{t("common.back")}</Button>
    </div>
  );
}
